import {AddLink, Description, Folder} from "@mui/icons-material"
import {IconButton} from "@mui/material"
import {useDispatch} from "react-redux"
import {fetchUsableDownloadLinkForAttachmentFile} from "../../../../../reducers/noteAttachmentsSlice"
import { createAndClickDownloadLinkFromBlob} from "../../../../../utils/domUtilities"
import axios from "axios"
import {useWorkspaceContext} from "../../../../../pages/Dashboard"

export function AttachmentIcon({attachment, handleClick, isTargetObject}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const handleFileClick = async (e) => {
		e.preventDefault()
		//first, if the attachment is not open, open the note
		if(!isTargetObject) {
			handleClick(e)
		}
		// then download the file.
		const {payload: clickableUrl} = await dispatch(fetchUsableDownloadLinkForAttachmentFile({attachmentId: attachment.id, workspaceId}))
		// to prevent images from opening in-browser, we download the file as a blob then use a fake click event on a fake link
		const {data: fileBlob} = await axios.get(clickableUrl, {
			// in App.js we set the Axios' default Headers to always include
			// JWT auth from auth0, and we need to remove those before
			// making a request to our S3 bucket
			transformRequest: (data, headers) => {
				delete headers.common["Authorization"]
				return data
			},
			responseType: "blob"
		})
		createAndClickDownloadLinkFromBlob(fileBlob, attachment.fileName)
	}

	if(["doc", "url"].includes(attachment?.attachmentType)) {
		return (
			<IconButton
				// MUI's button class takes all of the Anchor tag props: https://mui.com/material-ui/integrations/routing/#navigation-components
				href={attachment?.url?.startsWith("http") ? attachment?.url : `http://${attachment.url}`}
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleClick}
				sx={{
					"&:hover": {
						backgroundColor: "#eaeaea",
						color: "dragBar.pdfHover",
					},
					marginTop: "3px",
				}}
				mt={"3px"} // compensates for not being able to use align-items: "center" in parent container
			>
				{ attachment?.attachmentType === "url" && (
					<AddLink sx={{
						color: "#02B3C5",
						fontSize: "1.2rem"
					}}/>
				)}

				{ attachment?.attachmentType === "doc" && (
					<Description sx={{
						color: "#02B3C5",
						fontSize: "1.2rem"
					}}/>
				)}
			</IconButton>
		)
	} else {
		return (
			<IconButton
				onClick={handleFileClick}
				sx={{
					"&:hover": {
						backgroundColor: "#eaeaea",
						color: "dragBar.pdfHover",
					},
					marginTop: "3px", // compensates for not being able to use align-items: "center" in parent container
				}}
			>
				{ attachment?.attachmentType === "file" && (
					<Folder sx={{
						color: "#02B3C5",
						fontSize: "1.2rem"
					}}/>
				)}
			</IconButton>
		)
	}

}